import { IMasterBuildHook, MasterBuildHeaderPatch } from '@models';
import { CreateOrder } from '@services';
import { useStore } from '@stores';
import { useCallback, useEffect } from 'react';

export const useMasterBuild = (id?: string): IMasterBuildHook => {
  const { masterBuildStore } = useStore();
  const { build, loading, saving } = masterBuildStore;

  useEffect(() => {
    if (id) masterBuildStore.get({ id });
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  const refresh = useCallback(async () => {
    if (id) await masterBuildStore.get({ id });
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  /**
   * Update takes a partial, so the header sends only the fields it owns and leaves the rest of the
   * build alone. Every write returns the whole rehydrated build, so no refresh is needed.
   */
  const handleUpdate = useCallback(
    async (patch: MasterBuildHeaderPatch) => {
      if (!id) return;
      await masterBuildStore.update({ id, ...patch });
    },
    [id, masterBuildStore]
  );

  const handleAddOrder = useCallback(
    async (order: CreateOrder) => {
      if (!id) return;
      await masterBuildStore.addOrder(id, order);
    },
    [id, masterBuildStore]
  );

  const handleDeleteOrder = useCallback(
    async (orderId: string) => {
      if (!id) return;
      await masterBuildStore.deleteOrder(id, orderId);
    },
    [id, masterBuildStore]
  );

  return {
    build,
    loading,
    saving,
    refresh,
    handleUpdate,
    handleAddOrder,
    handleDeleteOrder,
  };
};
